import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToFinishInfoState = (state: IRootState) => state.recipient.finishInfo;

export const getIsLoading = pipe(pathToFinishInfoState, state => state.isLoading);

export const getErrors = pipe(pathToFinishInfoState, state => state.errors);

export const getMessage = pipe(pathToFinishInfoState, state => state.message);

export const getIsAnswerSending = pipe(pathToFinishInfoState, state => state.isAnswerSending);

export const getIsAnswerSent = pipe(pathToFinishInfoState, state => state.isAnswerSent);
